import React from "react";
import Tabs from '../Tabs/Tabs';
import ProductFolioItemPresenterTabContent from "./ProductFolioItemPresenterTabContent";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import numeral from "numeral";

class ProductFolioItemPresenter extends React.Component {
  constructor(props) {
    super(props)

    let amount = null
    if (this.props.folio_item && this.props.folio_item.total_amount && this.props.folio_item.quantity)  {
      amount = (this.props.folio_item.total_amount / this.props.folio_item.quantity)
    } else if (this.props.folio_item && this.props.folio_item.total_amount) {
      amount = this.props.folio_item.total_amount
    }

    this.state = {
      edit: this.props.edit,
      historical_version: this.props.historical_version,
      loading: false,
      active_tab: this.props.active_tab || 'general',
      tabs: true,
      amount: amount,
      notes: '',
      item_type: this.props.folio_item && this.props.folio_item_type ? this.props.folio_item_type : null,
      folio_item_source: this.props.folio_item && this.props.folio_item.folio_item_source ? this.props.folio_item.folio_item_source : null,
      product: this.props.folio_item && this.props.folio_item ? this.props.folio_item.product : null,
      quantity: this.props.folio_item && this.props.folio_item.quantity ? this.props.folio_item.quantity : 1,
      parent_folio_item_id: this.props.folio_item && this.props.folio_item.parent_folio_item_id ? this.props.folio_item.parent_folio_item_id : null,
      item_date: this.props.folio_item.item_date || new Date(),
      created_at: this.props.folio_item.created_at || new Date(),
      updated_at: this.props.folio_item.updated_at || new Date(),
      updated_by: this.props.folio_item.updated_by,
      status: this.props.folio_item.status,
      taxes: this.props.product_taxes ? this.props.product_taxes : [],

      tax_ids: this.getTaxes().tax_ids,

      // tax_ids: this.props.product_taxes && this.props.product_taxes.length ? this.props.product_taxes.map((tax) => { return tax.id}) : [],
      folio: this.props.folio,
      total_with_taxes: this.props.folio_item && this.props.folio_item.total_amount_with_taxes ? this.props.folio_item.total_amount_with_taxes : null,
      children: this.props.folio_item.children && this.props.folio_item.children.length ? this.props.folio_item.children : null,
      children_data_table_path: this.props.children_data_table_path,
      service_log: {
        assigned_to: this.props.service_log ? this.props.service_log.assigned_to : null,
        scheduled_at: this.props.service_log ? this.props.service_log.scheduled_at : new Date(),
        setTimeOpen: true,
        startTime: this.props.service_log ? this.props.service_log.start_time : null,
        endTime: this.props.service_log ? this.props.service_log.end_time : null,
        startedAt: this.props.service_log ? this.props.service_log.started_at : null,
        finishedAt: this.props.service_log ? this.props.service_log.finished_at : null,
        acknowledgedAt: this.props.service_log ? this.props.service_log.acknowledged_at : null,
        createdAt: this.props.service_log ? this.props.service_log.created_at : null,
        status: this.props.service_log ? this.props.service_log.status : null,
        description: this.props.service_log ? this.props.service_log.description : null,
        room: this.props.service_log ? this.props.service_log.room : this.props.reservation_segment ? this.props.reservation_segment.room : null,
      },
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null
      },
      image_group: this.props.image_group,
    }
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.formatCurrency = this.formatCurrency.bind(this);
  }



  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
    ]

    return (
        <div className="product-folio-item-builder" ref="root">
          <Tabs tabs={this.tabs()} edit_booking={this.props.edit_booking} />
          <div className="panel panel-form">
            <ProductFolioItemPresenterTabContent {...this.state}
              edit_booking={this.props.edit_booking}
              reservation_segment={this.props.reservation_segment}
              folio_item_revision_history_path={this.props.folio_item_revision_history_path}
              notes_endpoint={this.props.folio_item_notes_path}
              service_log_notes_path={this.props.service_log_notes_path}
              children_data_table_path={this.state.children_data_table_path}
              formatCurrency={this.formatCurrency}
              buttons={buttons}
              read_only={this.props.read_only}
              time_format={this.props.time_format}
              date_format={this.props.date_format}
             />
          </div>
          {this.renderTotal()}
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <LoadingSpinner show={this.state.loading} />
        </div>
    );
  };

  tabs() {
    if( this.props.edit_booking ) {
      return(
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          // {
          //   tabName: I18n.t('taxes_and_fees'),
          //   targetName: 'taxes_and_fees',
          //   classes: this.state.active_tab === 'taxes_and_fees' ? 'active' : null,
          //   changeHandler: this.onChangeActiveTab,
          // },
        ]
      )
    } else if (this.props.product && this.props.product.requires_service_request){
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('notes'),
            targetName: 'notes',
            classes: this.state.active_tab === 'notes' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('service_requests'),
            targetName: 'service_requests',
            classes: this.state.active_tab === 'service_requests' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      );
    } else {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('notes'),
            targetName: 'notes',
            classes: this.state.active_tab === 'notes' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      );
    };
  };

  calculatePrice() {
    var self = this;
    // console.log("this.state.tax_ids", this.state.tax_ids)
    self.setState({loading: true})
    // console.log("about to ajax, self.state.amount", self.state.amount);
    $.ajax({
      type: 'POST',
      url: self.props.calculate_price_path,
      data: {
        folio_item: {
          subtotal: self.state.amount,
          total_amount: self.state.amount * self.state.quantity,
          folio_id: self.state.folio ? self.state.folio.id : null,
          item_date: self.state.item_date,
          product_id: self.state.product ? self.state.product.id : null,
          rate_id: self.state.rate ? self.state.rate.id : null,
          guest_type_id: self.state.guest_type ? self.state.guest_type.id : null,
          quantity: self.state.quantity,
          rate_id: self.state.rate ? self.state.rate.id : null,
          fee_id: self.state.fee ? self.state.fee.id : null,
          room_type_id: self.state.room_type ? self.state.room_type.id : null,
        },
        session_id: self.props.folio_item.session_id ? self.props.folio_item.session_id : null,
        segment_temp_id: self.props.segment_temp_id ? self.props.segment_temp_id : null,
        tax_ids: self.state.tax_ids,
        fee_ids: self.state.fee_ids,
        calculate_taxes_and_fees: self.state.calculate_taxes_and_fees ? "inclusive" : "exclusive",
      }
    }).done(function(data) {
      $(window).trigger('refresh_data_table');

      if(data && data.errors && data.errors.length != 0) {
      } else {
        self.setState({
          // amount: data.folio_item.total_amount,
          loading: false,
          total_with_taxes: data.folio_item.total_amount_with_taxes,
        })
      }

    })
  }

  renderTotal() {
    if (this.state.total_with_taxes && this.state.total_with_taxes != 0) {
      return (
        <div className="accommodations-price-footer">
          <p className="lead" style={{marginBottom: 0}}>
            <label style={{marginBottom: 0}}>{I18n.t('total_with_taxes')}:</label>&nbsp;
            {this.formatCurrency(this.state.total_with_taxes)}
          </p>
        </div>
      );
    } else {
      return null;
    };
  };

  getTaxes() {
    
    let taxes
    
    let tax_ids
    if (this.props.fee_type) {
      taxes = this.props.folio_item.fee_taxes ? this.props.folio_item.fee_taxes : []
      tax_ids = this.props.folio_item.fee_taxes && this.props.folio_item.fee_taxes.length ? this.props.folio_item.fee_taxes.map((tax) => { return tax.id}) : []
    } else if (this.props.room_revenue || this.props.cancellation_fee) {
    taxes = this.props.folio_item.rate_taxes ? this.props.folio_item.rate_taxes : []
    tax_ids = this.props.folio_item.rate_taxes && this.props.folio_item.rate_taxes.length ? this.props.folio_item.rate_taxes.map((tax) => { return tax.id}) : []
    } else if (!this.props.room_revenue) {
      taxes = this.props.folio_item.product_taxes ? this.props.folio_item.product_taxes : []
      tax_ids = this.props.folio_item.product_taxes && this.props.folio_item.product_taxes.length ? this.props.folio_item.product_taxes.map((tax) => { return tax.id}) : []
    }
    return ({
      taxes: taxes,
      tax_ids: tax_ids,
    });
  };

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };
};

export default ProductFolioItemPresenter
